import { FacturePage } from "components/FacturePage"

export const Factures: React.FC = () => {
  return (
    <FacturePage />
  )
}